module.exports = "<div class=\"scroll-to-top\" [ngClass]=\"{'show-scrollTop': windowScrolled}\">\n    <button type=\"button\" class=\"btn active\" data-toggle=\"button\" aria-pressed=\"true\" (click)=\"scrollToTop()\">\n        <span class=\"glyphicon glyphicon-triangle-top\" aria-hidden=\"true\"></span>\n    </button>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Projects/milic/self-legal/src/app/scroll-to-top/scroll-to-top.html
// module id = ../../../../../src/app/scroll-to-top/scroll-to-top.html
// module chunks = main